import { Component, inject } from "@angular/core";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { Observable, of } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { ThirdPartyDataService } from "@pages/thirdparty/services/ThirdPartyDataService";
import { RendererConfig } from "@models/workspace/RendererConfig";
import { RendererType } from "@enums/RendererType";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "thirdparty-linkable",
    templateUrl: "./thirdparty-linkable.component.html",
    imports: [LinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class ThirdPartyLinkableComponent extends ItemLinkableBase {
    hasAccessChecks = {};
    accessCheckInProgress = false;

    rendererConfig: RendererConfig[] = [
        {
            textColumn: "Review score",
            actionColumn: "ReviewScoreColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
        {
            textColumn: "Criticality",
            actionColumn: "CriticalityColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
    ];

    private _tpDataService = inject(ThirdPartyDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._tpDataService.hasAccess(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.ThirdpartyDetail,
                item.guid,
                `(TP) ${item[this.displayValueProp]}`
            );
        } else {
            // t() needs the scope loaded first; before ready() it throws in development.
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t("thirdpartyLinkable.notEnoughRights")
            );
        }
    }
}
